import * as React from "react";
import { FC } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {
  backGroundColorCode,
  foreColorCode,
  foreColorCodeLite,
} from "../../../../commons/colors";
import { useRecoilValue } from "recoil";
import { userState } from "../../../../states/userState";
import { useTheme, useMediaQuery } from "@mui/material";

const classes = {
  statusMenu: {
    "& .MuiOutlinedInput-input": {
      paddingBottom: "7px",
      paddingTop: "7px",
    },
  },
};
type DateSelectorProps = {
  label: string;
  value: string;
  options: { id: string; name: string }[];
  select: (value: string) => void;
  required: boolean;
  disabled: boolean;
};

const DateSelector: FC<DateSelectorProps> = (props) => {
  const user = useRecoilValue(userState);
  const theme = useTheme(); // Get the current theme
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isIphone = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <FormControl
      variant="standard"
      sx={{
        // minWidth: 155,
        // width: isMobile ? 120 : 155,
        width: isIphone ? 110 : isMobile ? 120 : 155,
        // width: 10,
        marginBottom: "10px",
        marginRight: "0px",
      }}
    >
      <InputLabel sx={{ color: "primary.main" }}>{props.label}</InputLabel>
      <Select
        disabled={props.disabled}
        required={props.required}
        value={props.value}
        onChange={(event) => props.select(event.target.value)}
        label={props.label} // MUI v5では、選択した値とラベルを適切に揃えるためにこれを追加する必要があるかもしれません
        sx={{
          boxShadow:
            user?.mode === "lite"
              ? "0px 0px 3px 1px #898b92"
              : "0px 0px 3px 1px black",

          color: "primary.main",
          px: 1,
          height: "38px",
          fontSize: isMobile ? "12px" : "14px",
          borderRadius: "5px",
          backgroundColor: backGroundColorCode(user?.mode ?? "lite"),
          "& .MuiSvgIcon-root": {
            color: foreColorCode(user?.mode ?? "dark"),
          },
          "& .MuiSelect-select": {
            backgroundColor: backGroundColorCode(user?.mode ?? "lite"), // 選択エリアの背景色を設定
          },
        }}
        MenuProps={{
          PaperProps: {
            style: {
              backgroundColor: backGroundColorCode(user?.mode ?? "dark"),

              // 他のスタイルもここで指定できます。
            },
          },
        }}
      >
        {props.options.map((option) => (
          <MenuItem
            key={option.id}
            value={option.id}
            sx={{
              fontSize: isMobile ? "12px" : "14px",
              color: foreColorCodeLite(user?.mode ?? "lite"),
              backgroundColor: backGroundColorCode(user?.mode ?? "lite"),
              // 選択された状態のスタイル
              "&.Mui-selected": {
                backgroundColor: backGroundColorCode(user?.mode ?? "lite"), // 選択時の背景色を変更
                color: "primary.main", // 選択時の文字色を変更
              },

              // ホバー状態のスタイルも定義できます
              "&:hover": {
                backgroundColor: backGroundColorCode(user?.mode ?? "lite"), // ホバー時の背景色を変更
                color: "primary.main", // ホバー時の文字色を変更
              },
              // 選択されていてさらにホバーされた状態のスタイル
              "&.Mui-selected:hover": {
                backgroundColor: backGroundColorCode(user?.mode ?? "lite"), // 選択 + ホバー時の背景色
                color: "primary.main", // 選択 + ホバー時の文字色
              },
            }}
          >
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DateSelector;
